<template>
<div class="detail">

    <div class="container p-0" id="job-detail">

        <ol class="breadcrumbs">
            <router-link to="/dashboard">Dashboard</router-link> > Enquiry
        </ol>
        <div class="d-sm-flex align-items-top justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Enquiry: {{job.name}}</h1>
            <div v-if="user.data.role >= 8" class="no-print d-flex align-items-center align-self-center">
                <button v-if="!eMode" @click="toggleEdit()" class="btn btn-secondary"><i class="fas fa-fw fa-edit"></i> Edit Enquiry</button>
                <button v-if="!eMode" @click="printPage()" class="btn btn-info ml-2"><i class="fas fa-fw fa-print"></i> Page</button>
                <button v-if="eMode" @click="saveChanges()" class="btn btn-primary mr-2">Save Changes</button>
                <button v-if="eMode" @click="cancelChanges()" class="btn btn-warning">Cancel</button>
            </div>
        </div>

        <div v-if="error" class="mb-4 alert alert-danger">{{error}}</div>
        <div v-if="success" class="mb-4 alert alert-success">{{success}}</div>
        <div class="row multi-col" v-if="job && user">
            <div class="col-lg">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h5 class="panel-title">Enquiry #{{job.contactid}} Details</h5>
                    </div>
                    <div class="panel-body">
                        <table class="table focused detail-table">
                            <tbody>
                                <tr>
                                    <th>Date Created</th>
                                    <td>{{job.submitted | fullDate}}

                                        <small>{{job.createdBy}}</small>
                                    </td>
                                </tr>
                                <tr>
                                    <th>Status:</th>
                                    <td v-if="job.status && (!eMode || user.data.role <= 8)" class="pt-2">
                                        <h5 style="margin:auto 0;"><span :title="'Updated: ' + $options.filters.longDate(job.statusChangeDate)" style="margin:auto 0;" :style="{ background: $options.filters.statusHex(job.status)}" class="badge badge-lg">{{job.status}}</span><small style="font-size:12px;display:block;margin-top:2px;margin-bottom:-2px" v-if="job.statusChangeDate">Status Changed: {{job.statusChangeDate | longDate}}</small></h5>
                                    </td>
                                    <td v-if="job.status && eMode && user.data.role > 8" class="p-1">
                                        <select v-model="job.status" name="dataTable_length" required aria-controls="dataTable" class="custom-select form-control mb-0">
                                            <option>Created</option>
                                            <option>In Process</option>
                                            <option>Completed</option>
                                            <option>Cancelled</option>
                                        </select>
                                    </td>

                                </tr>
                                <tr>
                                    <th>Assigned To:</th>
                                    <td class="py-1" v-if="!eMode || user.data.role <= 8">
                                        <div v-if=" job.assignedTo"><span style="padding-right:0.75rem">{{job.assignedTo}}</span><span style="display:inline-block;" v-html="$options.filters.getCaps(job.assignedTo, job.assignedUID, users)"></span></div>
                                        <div class="p-0 py-2 m-0 btn btn-sm" v-if="!job.assignedTo">Unassigned</div>

                                    </td>
                                    <td v-if="eMode && user.data.role > 8" class="p-1">
                                        <select v-model="assignedUser" @change="onChangeAssigned()" name="dataTable_length" required aria-controls="dataTable" class="custom-select form-control mb-0">
                                            <option :value="null">Unassigned</option>
                                            <option :value="user" v-for="(user, i) in users" v-bind:key="i">{{user.name}}</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>


            <div class="col-lg">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h5 class="panel-title">Contact Details</h5>
                    </div>
                    <div class="panel-body" style="padding:0;">
                        <table class="table focused detail-table">
                            <tbody>

                                <tr>
                                    <th>Business</th>
                                    <td v-if="!eMode">{{job.company}}</td>
                                    <td v-if="eMode" class="p-1"><input id="company" type="text" class="form-control mb-0" name="company" v-model="job.company" /></td>
                                </tr>

                                <tr>
                                    <th>Name</th>
                                    <td v-if="!eMode"><span>{{job.name}}</span></td>
                                    <td v-if="eMode" class="p-1"><input id="name" type="text" class="form-control mb-0" name="name" v-model="job.name" /></td>
                                </tr>
                                <tr>
                                    <th>Email</th>
                                    <td v-if="!eMode">{{job.email}} <br />
                                        <router-link class="no-print" :to="{ name: 'job-search', query: { email:job.email } }">
                                            <small><i class="fas fa-search fa-sm"></i> Other Jobs by User</small>
                                        </router-link>
                                    </td>
                                    <td v-if="eMode" class="p-1"><input id="email" type="email" class="form-control mb-0" name="email" v-model="job.email" /></td>
                                </tr>
                                <tr>
                                    <th>Phone</th>
                                    <td v-if="!eMode"><span>{{job.phone}}</span></td>
                                    <td v-if="eMode" class="p-1"><input id="phone" type="tel" class="form-control mb-0" name="phone" v-model="job.phone" /></td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row pt-3 mb-3 no-print card" v-if="job">
            <div class="col-lg">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h5 class="panel-title"><i class="fas fa-fw fa-comment"></i> Customer Enquiry</h5>
                    </div>
                </div>
                <div class="panel-body">
                    <p class="pt-2 pb-4 comment-text">{{job.message}}</p>
                </div>
            </div>
        </div>
        <div class="row pt-3 mb-3 no-print card" v-if="job">
            <div class="col-sm">
                <div class="panel panel-default">
                    <div class="panel-heading d-flex justify-content-between">
                        <h5 class="panel-title"><i class="fas fa-fw fa-file"></i> File Attachments</h5>
                        <file-upload :job="job"></file-upload>
                    </div>
                    <div class="panel-body" v-if="job.adminAttachments && job.adminAttachments.length > 0 || job.attachment">
                        <div class="table-responsive-xl">
                            <div>
                                <table class="fixed fixed-lg">
                                    <thead>
                                        <tr>
                                            <th>Date Uploaded</th>
                                            <th>Entered by</th>
                                            <th class="col-address">File</th>
                                            <th>Size</th>
                                            <th>Last Modified</th>
                                            <th class="col-arrow" v-if="eMode"></th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="job.adminAttachments && job.adminAttachments.length > 0">
                                        <tr class="rw" v-for="(att, i) in job.adminAttachments.slice().reverse()" v-bind:key="i">
                                            <td :time="att.submitted">{{att.submitted | longDate}}</td>
                                            <td><span class="pr-2">{{att.enteredBy}}</span><span style="margin-top:-0.75rem;margin-bottom:-0.75rem;display:inline-block;" v-html="$options.filters.getCaps(att.enteredBy, att.enteredUID, users, true)"></span></td>
                                            <td class="col-address"><a class="d-block mb-1" :href="att.path">{{att.name}}</a></td>
                                            <td>{{Math.floor(att.size / 1000)}}kb</td>
                                            <td :time="att.lastModified">{{att.lastModified | shortDate}}</td>
                                            <td class="col-arrow" v-if="eMode"><button style="margin:-0.75rem;" class="btn btn-sm" @click="deleteItem((job.adminAttachments.length-1) - i, 'adminAttachments')"><i class="fas text-danger fa-fw fa-trash"></i></button></td>
                                        </tr>
                                    </tbody>
                                    <tbody v-if="job.attachment">
                                        <tr class="rw">
                                            <td :time="job.submitted">{{job.submitted | longDate}}</td>
                                            <td><span class="pr-2">Customer ({{job.name}})</span></td>
                                            <td class="col-address"><a class="d-block mb-1" :href="'https://booking.echotech.co.nz/wp-content/themes/blankslate/uploads/'+job.attachment">{{job.attachment}}</a></td>
                                            <td></td>
                                            <td :time="job.submitted">{{job.submitted | shortDate}}</td>
                                            <td class="col-arrow" v-if="eMode"></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row pt-3 mb-3 card" v-if="job" style="display: none;">
            <div class="col-sm">
                <div class="panel panel-default">
                    <div class="panel-heading">
                        <h5 class="panel-title"><i class="fas fa-fw fa-comments"></i> Notes</h5>
                    </div>
                    <div class="panel-body">
                        <div class="table-responsive-xl" v-if="jobNotes && jobNotes.length>0">
                            <div>
                                  <table class="table focused">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th class="col-date">Type</th>
                                            <th>Entered by</th>
                                            <th class="col-address">Message</th>
                                            <th>Seen</th>
                                            <th class="col-arrow" v-if="eMode"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="rw" v-bind:class="{highlightRow: !jobNote.viewDate && jobNote.viewForID === user.auth.uid }" v-for="(jobNote, index) in jobNotes" v-bind:key="index">
                                            <td class="col-date" :time="jobNote.submitted">{{jobNote.submitted | longDate}}</td>
                                            <td class="col-date">{{jobNote.type}}</td>
                                            <td><span class="pr-2">{{jobNote.enteredby}}</span><span style="margin-top:-0.75rem;margin-bottom:-0.75rem;display:inline-block;" v-html="$options.filters.getCaps(jobNote.enteredby, jobNote.enteredUID, users, true)"></span></td>
                                            <td class="col-address">{{jobNote.message}}</td>
                                            <td>
                                                <small v-if="jobNote.viewDate">Seen by <span style="margin-top:-0.75rem;margin-bottom:-0.75rem;display:inline-block;" v-html="$options.filters.getCaps(jobNote.viewFor, jobNote.viewForID, users, true)"></span> {{jobNote.viewDate | shortDate }}</small>
                                                <small v-if="!jobNote.viewDate && jobNote.viewFor">Not Seen by <span style="margin-top:-0.75rem;margin-bottom:-0.75rem;display:inline-block;" v-html="$options.filters.getCaps(jobNote.viewFor, jobNote.viewForID, users, true)"></span> </small> 
                                                <button v-if="!jobNote.viewDate && jobNote.viewForID === user.auth.uid" style="margin-top:-0.25rem;margin-bottom:-0.25rem;" class="ml-2 btn btn-info btn-xs" @click="viewNote(jobNote, job, 'contactNotes')"><i class="fas text-white fa-fw fa-check"></i> Mark Seen</button>
                                            </td>
                                            <td class="col-arrow" v-if="eMode && jobNote.enteredUID === user.auth.uid"><button style="margin-top:-0.5rem;margin-bottom:-0.25rem;" class="btn btn-sm" @click="deleteNote(jobNote, job, 'contactNotes')"><i class="fas text-danger fa-fw fa-trash"></i></button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr class="no-print" />
                        <job-note class="no-print" named="Enquiry" notesRef="contactNotes" :job="job"></job-note>

                    </div>
                </div>
            </div>
        </div>


       

        <div class="row pt-3 mb-5 no-print card" v-if="job && user.data.role >= 8">
            <div class="col-sm">
                <div class="panel panel-default">
                    <div class="panel-heading d-flex justify-content-between" @click="expandLogSection">
                        <h5 class="panel-title"><i class="fas fa-fw fa-user-edit"></i> Change Log</h5>
                        <button class="btn"><i v-bind:class="{'fa-chevron-down': !expandLog, 'fa-chevron-up': expandLog}" class="fas fa-fw"></i></button>
                    </div>
                    <div class="panel-body" v-bind:class="{'d-none': !expandLog}">

                        <p v-if="changeLogs && changeLogs.length === 0" class="text-center pt-0 pb-4">No Change Logs Created</p>
                        <div class="table-responsive-xl" v-if="changeLogs && changeLogs.length>0">
                            <div>
                                <table class="fixed fixed-lg">
                                    <thead>
                                        <tr>
                                            <th>Date</th>
                                            <th class="col-date">Type</th>
                                            <th>Change Made by</th>
                                            <th class="col-address col-address-lg">Changed From</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="rw" v-for="(jobNote, index) in changeLogs" v-bind:key="index">
                                            <td :time="jobNote.submitted">{{jobNote.submitted | longDate}}</td>
                                            <td class="col-date">{{jobNote.type}}</td>
                                            <!--<td>{{job.collection}}</td>-->
                                            <td><span  style="padding-right:0.25rem">{{jobNote.enteredby}}</span><span style="margin-top:-0.75rem;margin-bottom:-0.75rem;display:inline-block;" v-html="$options.filters.getCaps(jobNote.enteredby, jobNote.enteredUID, users, true)"></span></td>
                                            <td class="col-address col-address-lg" style="white-space:normal;line-height:1;">
                                                <span v-if="jobNote.message.status" :style="{ background: $options.filters.statusHex(jobNote.message.status)}" class="badge badge-lg mr-2">{{jobNote.message.status}}</span>
                                                <span v-if="jobNote.message.assignedUID" style="padding-right:0.25rem">{{jobNote.message.assignedTo}}</span><span style="display:inline-block;" v-html="$options.filters.getCaps(jobNote.message.assignedTo, jobNote.message.assignedUID, users, true)"></span>

                                                <div style="margin-top:2px;"><small style="font-size:13px" v-for="(value, key, ind) in jobNote.message" v-bind:key="ind">{{key | camelToWords}}: {{value}}, </small></div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import {
    db
} from '../main'

import {
    mapGetters
} from "vuex";

import saveNoteMixin from "../mixins/saveNotes";
import JobNote from "@/components/JobNote";
import FileUpload from "@/components/FileUpload";

const jobs = db.ref("contactForm2020");

//const jobNotesRef = db.ref("jobNotes");
const changeLogsRef = db.ref("changeLogsEnquiry");


export default {
    name: "Detail",
    components: {
        JobNote,
        FileUpload,
    },
    mixins: [saveNoteMixin],
    //props: ['id'],
    data() {
        return {
            eMode: false,
            changeLogsRaw: [],
            expandLog: false,
            job: null,
            key: this.$route.params.key, //this.$route.params.id
            contactid: parseInt(this.$route.params.id, 10),
            jobsRaw: [],
            inwardsRaw: [],
            inwardsList: [],
            jobNotesRaw: [],
            timesheetsRaw: [],
            time: {},
            users: [],
            error: null,
            assignedUser: null,
            success: null
        };
    },
    firebase: {
        users: db.ref('users').orderByChild('role').limitToLast(50).startAt(8),
    },
    computed: {
        ...mapGetters({
            user: "user",
            orgs: "orgs"
        }),
        jobNotes: function () {
            return [...this.jobNotesRaw].reverse();
        },

        changeLogs: function () {
            var arr = [...this.changeLogsRaw].reverse();
            arr.forEach(function(item){
                var messageObj = JSON.parse(item.message);
                item.message = messageObj;
                console.log('messageObj', messageObj);
                for (const [key] of Object.entries(messageObj)) {
                    if(key === "hasNoteID") delete messageObj[key];
                    if(key === "hasNoteUserID") delete messageObj[key];

                }
            })
            console.log("messageArrry", arr)

            return arr;
        }
    },
    created() {
        // this.selectedRow(12802);
        this.$store.dispatch('bindOrgs')
    },
    methods: {

        disabledAfterToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);

            return date > today;
        },
        expandLogSection() {
            const t = this;
            t.expandLog = !t.expandLog;
            if (t.job && !t.changeLogs.length > 0) {
                t.$rtdbBind("changeLogsRaw", changeLogsRef.orderByChild("contactid").equalTo(parseInt(this.job.contactid, 10))).then(changeLogsRaw => {
                    // documents will be an array if this.documents was initially set to an array
                    // and it will point to the same property declared in data:
                    //this.jobsRaw === jobsRaw;
                    console.log('changeLogs', changeLogsRaw);
                    console.log('changeLogs', t.changeLogs);
                })
            }
        },
        deleteAttachment(i) {
            const t = this;
            //Remove From User table
            t.job.adminAttachments.splice(i, 1);
            t.saveChanges();
            //Remove User
        },
        deleteChangeLog(i) {
            const t = this;
            db.ref('changeLogEnquiry/' + t.changeLogs[i]['.key']).remove();
        },
        printPage() {
            window.print();
        },
        onChangeAssigned() {
            const t = this;
            if (t.assignedUser !== null) {
                t.job.assignedTo = t.assignedUser.name;
                t.job.assignedUID = t.assignedUser['.key'];
            } else {
                t.job.assignedTo = null;
                t.job.assignedUID = null;
            }
        },
        deleteItem(i, item) {
            const t = this;
            console.log(typeof t.job[item]);
            t.job[item].splice(i, 1);
            console.log(t.job[item]);
        },
        cancelChanges(){
            location.reload();
        }, 
        toggleEdit() {
            const t = this;
            t.eMode = !t.eMode;
            t.success = null;
            t.error = null;
            /*t.job = JSON.parse(JSON.stringify(t.jobOriginal));
            setTimeout(function () {
                t.assignedUser = t.users.filter(function (item) {
                    return item['.key'] === t.job.assignedUID;
                })[0];
            }, 1000);*/
        },

        saveChanges(dontSaveNote) {
            const t = this;
            console.log('savejob', t.job);
            console.log('jobOriginal', t.jobOriginal);
            if (t.job.status) {
                if (!t.jobOriginal.status) {
                    t.job.statusChangeDate = new Date().toISOString();
                } else {
                    if (t.jobOriginal.status !== t.job.status) {
                        t.job.statusChangeDate = new Date().toISOString();
                    }
                }

            }

            db.ref('contactForm2020/' + t.job['.key'])
                .set(t.job)
                .then(() => {
                    console.log('Enquiry updated!')
                    t.success = "Enquiry Changes Saved";
                    t.eMode = false;
                    var diff = JSON.stringify(t.diffObj(t.job, t.jobOriginal))
                    console.log('diff', diff);
                    if (diff !== '{}' && !dontSaveNote) {
                        t.saveNote(diff, t.job, 'Edit', null, false, "contactNotes");
                    }
                })
        },
        addNewItem() {
            var item = {
                description: '',
                item: ''
            }
            this.job.items.push(item);
        },
        checkIfImage(filename) {
            var fileExt = filename.substr(filename.lastIndexOf('.') + 1);
            switch (fileExt.toLowerCase()) {
                case "jpg":
                case "jpeg":
                case "png":
                case "gif":
                    return true;
                default:
                    return false;
            }
        },
        setJobOriginal() {
            const t = this;
            t.jobOriginal = JSON.parse(JSON.stringify(t.job));
            console.log('users', t.users);
            console.log('users', t.jobOriginal);
            setTimeout(function () {
                t.assignedUser = t.users.filter(function (item) {
                    return item['.key'] === t.job.assignedUID;
                })[0];
            }, 1000)
            // console.log('assigned', t.assignedUser);
        }
    },
    watch: {
        key: {
            // call it upon creation too
            immediate: true,
            handler(key) {
                if (key) {
                    const t = this;
                    this.$rtdbBind("job", jobs.child(key)).then(snap => {
                        console.log(snap);
                        console.log('job from Key', t.job);
                        t.setJobOriginal();
                    })
                }
            }
        },
        contactid: {
            // call it upon creation too
            immediate: true,
            handler(contactid) {
                if (!this.key) {
                    console.log('contactidfind', contactid);
                    const t = this;
                    this.$rtdbBind("jobsRaw", jobs.orderByChild("contactid").equalTo(parseInt(contactid, 10))).then(jobsRaw => {
                        // documents will be an array if this.documents was initially set to an array
                        // and it will point to the same property declared in data:
                        console.log('jobsRaw', jobsRaw[0]);
                        //console.log('t.jobsRaw', t.jobsRaw[0]);
                        if (t.jobsRaw[0]) {
                            t.job = t.jobsRaw[0]
                            t.setJobOriginal();
                        } else {
                            this.error = "Enquiry # " + contactid + " not found"
                        }
                        //this.jobsRaw === jobsRaw;
                    })
                }
            }
        },
        /*job: {
            // call it upon creation too
            immediate: true,
            handler(inwardsArr) {
                if (this.job && this.job.inwards && this.job.inwards.length > 0) {
                    console.log('jobid', inwardsArr);
                    this.$rtdbBind("inwardsRaw", inwardsRef.orderByChild("jobid").equalTo(parseInt(this.job.jobid, 10))).then(inwardsRaw => {
                        // documents will be an array if this.documents was initially set to an array
                        // and it will point to the same property declared in data:
                        console.log('inwardsRaw', inwardsRaw);
                        if (this.inwardsRaw && this.inwardsRaw.length > 0) {
                            this.inwardsList = this.inwardsRaw
                        } else {
                            this.error = "Inwards Good for Job# " + this.$options.filters.jobid(this.job.jobid) + " not found"
                        }
                        //this.jobsRaw === jobsRaw;
                    })
                }
                if (this.job) {
                    this.$rtdbBind("jobNotesRaw", jobNotesRef.orderByChild("jobid").equalTo(parseInt(this.job.jobid, 10))).then(jobNotesRaw => {
                        // documents will be an array if this.documents was initially set to an array
                        // and it will point to the same property declared in data:
                        //this.jobsRaw === jobsRaw;
                        console.log('jobNotes', jobNotesRaw);
                        //console.log('jobNotes', this.jobNotes);
                    })
                }
                if (this.job && this.job.organisation) {
                    this.$rtdbBind("timesheetsRaw", timesheetsRef.orderByChild("jobid").equalTo(parseInt(this.job.jobid, 10))).then(timesheetsRaw => {
                        // documents will be an array if this.documents was initially set to an array
                        // and it will point to the same property declared in data:
                        //this.jobsRaw === jobsRaw;
                        console.log('timesheetsRaw', timesheetsRaw);
                        //console.log('jobNotes', this.jobNotes);
                    })
                }
            }
        }*/
    }
};
</script>

<style>
.panel-title {
    margin-bottom: .75rem;
}

.panel-heading .btn {
    margin-top: -.75rem;
    margin-bottom: -.25rem;
}
p.comment-text{
    line-height:1.75rem;
    font-size:1.15rem;
    max-width:800px;
    margin:0 auto;
}
</style>
